import { defineMessages } from 'react-intl';

/** The "All files" search of Releases (design assets-rethink d4). */
export const allFilesMessages = defineMessages({
  open: { id: 'app.sml.releases.allFiles.open', defaultMessage: 'All files' },
  shortcut: { id: 'app.sml.releases.allFiles.shortcut', defaultMessage: 'Find any file (⌘K)' },
  title: { id: 'app.sml.releases.allFiles.title', defaultMessage: 'All files' },
  placeholder: {
    id: 'app.sml.releases.allFiles.placeholder',
    defaultMessage: 'Find a file by song or type',
  },
  groupKeepers: { id: 'app.sml.releases.allFiles.group.keepers', defaultMessage: 'Release kit' },
  groupPosts: { id: 'app.sml.releases.allFiles.group.posts', defaultMessage: 'Posts' },
  groupUploads: { id: 'app.sml.releases.allFiles.group.uploads', defaultMessage: 'Your uploads' },
  placeKit: { id: 'app.sml.releases.allFiles.place.kit', defaultMessage: '{song} · Kit tab' },
  placeMaking: { id: 'app.sml.releases.allFiles.place.making', defaultMessage: '{song} · Making {percent}%' },
  placeFailed: { id: 'app.sml.releases.allFiles.place.failed', defaultMessage: '{song} · Failed' },
  placePost: { id: 'app.sml.releases.allFiles.place.post', defaultMessage: '{song} · Posts' },
  placeArchive: { id: 'app.sml.releases.allFiles.place.archive', defaultMessage: '{song} · Archive' },
  placeUploadPost: {
    id: 'app.sml.releases.allFiles.place.uploadPost',
    defaultMessage: 'Uploaded in the Composer · in a post',
  },
  placeUploadComposer: {
    id: 'app.sml.releases.allFiles.place.uploadComposer',
    defaultMessage: 'Uploaded in the Composer',
  },
  placeUploadLogo: { id: 'app.sml.releases.allFiles.place.uploadLogo', defaultMessage: 'Logo of the kit' },
  untitled: { id: 'app.sml.releases.allFiles.untitled', defaultMessage: 'A file with no name' },
  cover: { id: 'app.sml.releases.allFiles.cover', defaultMessage: 'Cover' },
  reel: { id: 'app.sml.releases.allFiles.reel', defaultMessage: 'AI reel {length}' },
  noSong: { id: 'app.sml.releases.allFiles.noSong', defaultMessage: 'No song' },
  empty: { id: 'app.sml.releases.allFiles.empty', defaultMessage: 'No file matches "{query}".' },
  nothing: { id: 'app.sml.releases.allFiles.nothing', defaultMessage: 'No files yet. Make one in Studio.' },
});
